import * as Common from '@/tenant/common';

export class SendPaymentScheduledReportQuery extends Common.Query {
    constructor(){
        super("SendPaymentScheduledReportQuery", null);
    }
    public templateId:number=0;
    public counterpart: Common.Counterpart = null;
    public segment: Common.Segment = null;
    public slipType:number = null;
    public isIncludeBalanceZero:boolean = false;
    public startDate: Date = null;
    public endDate: Date = null;
    public onExcelExport:boolean = false;           
}

export class SendPaymentScheduledReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SendPaymentScheduledReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}